"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addAnnualMotorCommands = void 0;
var HandleEditPhoneNumberPopupCommand_1 = require("./HandleEditPhoneNumberPopupCommand");
var CheckRenewalChangesModifiedCommand_1 = require("./CheckRenewalChangesModifiedCommand");
var RemoveDriverCommand_1 = require("./RemoveDriverCommand");
var LoadVehicleDriversCommand_1 = require("./LoadVehicleDriversCommand");
var SkipPaymentChoiceFlagCommand_1 = require("./SkipPaymentChoiceFlagCommand");
var SetAdditionalDriverNameCommand_1 = require("./SetAdditionalDriverNameCommand");
var StopAutoRenewalCommand_1 = require("./StopAutoRenewalCommand");
var AddConvictionsToDriverCommand_1 = require("./AddConvictionsToDriverCommand");
var RemoveConvictionCommand_1 = require("./RemoveConvictionCommand");
var CheckMainDriverRemovedCommand_1 = require("./CheckMainDriverRemovedCommand");
var addAnnualMotorCommands = function (extensions) {
    extensions.journeyComponents.addCommand({
        id: "handleEditPhoneNumberPopup",
        component: HandleEditPhoneNumberPopupCommand_1.HandleEditPhoneNumberPopupCommand
    });
    extensions.journeyComponents.addCommand({
        id: "checkRenewalChangesModified",
        component: CheckRenewalChangesModifiedCommand_1.CheckRenewalChangesModifiedCommand
    });
    extensions.journeyComponents.addCommand({
        id: "removeDriver",
        component: RemoveDriverCommand_1.RemoveDriverCommand
    });
    extensions.journeyComponents.addCommand({
        id: "loadVehicleDrivers",
        component: LoadVehicleDriversCommand_1.LoadVehicleDriversCommand
    });
    extensions.journeyComponents.addCommand({
        id: "skipPaymentChoiceFlag",
        component: SkipPaymentChoiceFlagCommand_1.SkipPaymentChoiceFlagCommand
    });
    extensions.journeyComponents.addCommand({
        id: "setAdditionalDriverNameCommand",
        component: SetAdditionalDriverNameCommand_1.SetAdditionalDriverNameCommand
    });
    extensions.journeyComponents.addCommand({
        id: "stopAutoRenewal",
        component: StopAutoRenewalCommand_1.StopAutoRenewalCommand
    });
    extensions.journeyComponents.addCommand({
        id: "addConviction",
        component: AddConvictionsToDriverCommand_1.AddConvictionsToDriverCommand
    });
    extensions.journeyComponents.addCommand({
        id: "removeConviction",
        component: RemoveConvictionCommand_1.RemoveConvictionCommand
    });
    extensions.journeyComponents.addCommand({
        id: "isMainDriverRemoved",
        component: CheckMainDriverRemovedCommand_1.CheckMainDriverRemovedCommand
    });
};
exports.addAnnualMotorCommands = addAnnualMotorCommands;
//# sourceMappingURL=index.js.map